/**
 * #7748 / #6917 — Marketplace (.com) → Association (.org) handoff mint client (PE).
 *
 * Primary path is Liquid-first GET /api/handoff/mint (no JS required).
 * This enhancement only intercepts direct /membership/* Association hrefs
 * (mint setting off / legacy) and POSTs /api/handoff/mint before navigate.
 *
 * Auth success ≠ purchasing (rule 38).
 */
(function () {
  "use strict";

  var ASSOC_HOST = "amishproductsassociation.org";
  var MINT_PATH = "/api/handoff/mint";
  var MEMBERSHIP_RE = /^\/membership(\/|$)/i;
  var BUSY = false;

  function associationOrigin() {
    var meta = document.querySelector(
      'meta[name="pma-association-origin"], [data-pma-association-origin]'
    );
    if (meta) {
      var fromMeta =
        meta.getAttribute("content") ||
        meta.getAttribute("data-pma-association-origin") ||
        "";
      if (fromMeta.indexOf("https://") === 0) return fromMeta.replace(/\/$/, "");
    }
    return "https://" + ASSOC_HOST;
  }

  function isAssociationMembershipUrl(href) {
    try {
      var u = new URL(href, window.location.href);
      if (u.hostname !== ASSOC_HOST && u.hostname !== "www." + ASSOC_HOST) {
        return false;
      }
      if (u.pathname.indexOf(MINT_PATH) === 0) return false;
      return MEMBERSHIP_RE.test(u.pathname);
    } catch (e) {
      return false;
    }
  }

  function parseReturnContext(url) {
    var out = {};
    if (url.searchParams.get("path")) out.path = url.searchParams.get("path");
    if (url.searchParams.get("product"))
      out.product = url.searchParams.get("product");
    if (url.searchParams.get("collection"))
      out.collection = url.searchParams.get("collection");
    var pathParts = url.pathname.split("/").filter(Boolean);
    if (pathParts[0] === "membership" && pathParts[1]) {
      out.journey = pathParts[1] === "apply" ? "apply" : pathParts[1];
    } else if (pathParts[0] === "membership") {
      out.journey = "membership";
    }
    return out;
  }

  function appendToken(href, token) {
    var u = new URL(href, window.location.href);
    u.searchParams.delete("apa_handoff");
    u.searchParams.delete("handoff");
    u.searchParams.delete("ht");
    u.searchParams.set("apa_handoff", token);
    return u.toString();
  }

  function mintThenNavigate(href) {
    if (BUSY) return;
    BUSY = true;
    var target = new URL(href, window.location.href);
    var body = parseReturnContext(target);
    var mintUrl = associationOrigin() + MINT_PATH;

    fetch(mintUrl, {
      method: "POST",
      mode: "cors",
      credentials: "omit",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { res: res, data: data };
        });
      })
      .then(function (pack) {
        BUSY = false;
        if (
          pack.res.ok &&
          pack.data &&
          pack.data.ok &&
          typeof pack.data.token === "string" &&
          pack.data.token.indexOf(".") > 0
        ) {
          window.location.assign(appendToken(href, pack.data.token));
          return;
        }
        window.location.assign(href);
      })
      .catch(function () {
        BUSY = false;
        window.location.assign(href);
      });
  }

  function onClick(event) {
    if (event.defaultPrevented) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var el = event.target;
    if (!el || typeof el.closest !== "function") return;
    var anchor = el.closest("a[href]");
    if (!anchor) return;
    var href = anchor.getAttribute("href");
    if (!href || !isAssociationMembershipUrl(href)) return;
    if (/[?&](apa_handoff|handoff|ht)=/.test(href)) return;

    event.preventDefault();
    mintThenNavigate(href);
  }

  document.addEventListener("click", onClick, true);
})();
